import React from 'react'

const HECSHelpButton = props => {
  return props.ineligibleForHECSHelpInd === 'Y' ? null : (
    <div className="question-group question-group-divider">
      <h3>You are eligible for a Commonwealth Supported Place (CSP)</h3>

      {(props.citizenCode === '1' || props.citizenCode === '2' || props.citizenCode === '3' || props.citizenCode === '8') && (
        <div className="financial-content">
          <p>
            As a student eligible for a CSP, this means that part of your course fees will be paid for by the Australian Government. To cover the remaining amount, you can either apply for a
            HECS-HELP loan or pay it before your first enrolled census date.
          </p>

          <p>
            To accept your CSP and apply for a HECS-HELP loan, you must submit an electronic Commonwealth Assistance Form (eCAF) – including your Tax File Number (TFN) and Unique Student
            Identifier (USI) – before census date. For more information on the eCAF process and how to complete it, go{' '}
            <a href={props.ecafLink} target={'_blank'}>
              here
            </a>
            .
          </p>

          <p>
            <a className={`btn btn-financial-margin btn-financial-small btn-primary center ${props.isHelpSubmitted === 'Y' ? 'disabled-link' : ''}`} href={props.link}>
                Accept your CSP
              </a>
          </p>
        </div>
      )}
    </div>
  )
}

export default HECSHelpButton
